import darkTheme from './darkTheme';
import lightTheme from './lightTheme';

export { darkTheme, lightTheme };



// WEBPACK FOOTER //
// ./src/Shared/Themes/index.js